export enum SubscriptionTiers {
  Free = 'Free',
  MLSFree = 'MLSFree',
  EarlyAdopter = 'EarlyAdopter',
  Starter = 'Starter',
  Professional = 'Professional',
  Enterprise = 'Enterprise',
  ProfessionalPlus = 'ProfessionalPlus',
  ProConcierge = 'ProConcierge',
  Build = 'Build',
  Amplify = 'Amplify',
  Attract = 'Attract',
}

export enum SubscriptionPlanType {
  Agent = 'Agent',
  Agency = 'Agency',
  Network = 'Network',
}

export function GetSubscriptionTierRank(tier: SubscriptionTiers) {
  switch (tier) {
    case SubscriptionTiers.Enterprise:
    case SubscriptionTiers.Attract:
      return 5;
    case SubscriptionTiers.ProConcierge:
      return 4;
    case SubscriptionTiers.ProfessionalPlus:
      return 3;
    case SubscriptionTiers.Professional:
    case SubscriptionTiers.Amplify:
      return 2;
    case SubscriptionTiers.Starter:
    case SubscriptionTiers.Build:
      return 1;
    case SubscriptionTiers.EarlyAdopter:
    case SubscriptionTiers.MLSFree:
    case SubscriptionTiers.Free:
    default:
      return 0;
  }
}

export function GetSubscriptionTier(tier?: number) {
  switch (tier) {
    case 301:
      return SubscriptionTiers.Attract;
    case 300:
      return SubscriptionTiers.Enterprise;
    case 275:
      return SubscriptionTiers.ProConcierge;
    case 250:
      return SubscriptionTiers.ProfessionalPlus;
    case 201:
      return SubscriptionTiers.Amplify;
    case 200:
      return SubscriptionTiers.Professional;
    case 101:
      return SubscriptionTiers.Build;
    case 100:
      return SubscriptionTiers.Starter;
    case 50:
      return SubscriptionTiers.MLSFree;
    case 25:
      return SubscriptionTiers.EarlyAdopter;
    default:
      return SubscriptionTiers.Free;
  }
}

export const SubscriptionTiersToHide = [
  SubscriptionTiers.Starter,
  SubscriptionTiers.Professional,
  SubscriptionTiers.Enterprise,
  SubscriptionTiers.ProfessionalPlus,
  SubscriptionTiers.ProConcierge,
];
